import { CURRENCIES } from '../constants/app'
import { formatTicks } from './string.helpers'

export const floorNumber = (n) => Math.floor(n)

export const percentageOfCompletion = (current, total) => {
  const completed = (current / total) * 100
  return Math.round(completed)
}

export const formatToDecimals = (n, m) => n.toFixed(m)

export const formatCurrencyValue = (value, maxDigits = 3) => {
  return value ? parseFloat(formatToDecimals(parseFloat(value), maxDigits)) : 0
}

export const formatEthCurrency = (value, maxDigits = 3) => {
  return `${formatTicks(formatCurrencyValue(value, maxDigits))} ${CURRENCIES.DEFAULT}`
}

export const formatEth = (value) => {
  return `${formatTicks(value)} ${CURRENCIES.DEFAULT}`
}

export const formatCurrencyShort = (value) => {
  return formatTicks(formatCurrencyValue(value))
}

export const formatOrdinal = (number) => {
  if (number > 3 && number < 21) return `${formatTicks(number)}th`

  switch (number % 10) {
    case 1:
      return `${formatTicks(number)}st`
    case 2:
      return `${formatTicks(number)}nd`
    case 3:
      return `${formatTicks(number)}rd`
    default:
      return `${formatTicks(number)}th`
  }
}

export const formatPts = (value) => {
  return `${formatTicks(value)} ${CURRENCIES.PTS}`
}

export const formatMulti = (value) => {
  return `${value}x`
}
